import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BasicBreadcrumbs from "@material-ui/core/Breadcrumbs";

import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import ButtonIconComponent from "../Components/ButtonIcons";
import InputField from "../Components/inputfield";
import {
  RemoveRedEye as RemoveRedEyeIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import ButtonComponent from "../Components/buttton";
import { AddSingleDoc, GetAllData, UpdateSingleDoc, DeleteSingleData } from "../NetworkCalls/Admin/ServerReq";
import RemoveButton from "../Components/AlertDialog";

const Divider = styled(MuiDivider)(spacing);

const FoodCategory = () => {
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [loader, setLoader] = useState(false);
  const [loaderAddCategory, setLoaderAddCategory] = useState(false)
  const [data, setData] = useState();
  const [category, setCategory] = useState({})

  function handleRemove(id) {
    DeleteSingleData("Categories", id)

    const result = data?.filter((item) => item?.id != id)
    setData(result);
  }

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setCategory({ ...category, [name]: value })
  }
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoader(true)
      let arr = [];
      const response = await GetAllData("Categories");
      response.forEach((doc) => {
        arr.push(doc.data())
      });
      arr.sort((a, b) => a.name.localeCompare(b.name));
      setData(arr)
      setLoader(false)
    } catch (error) {
      console.log(error)
      setLoader(false)
    }
  }

  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: "10px" }}
        justify='space-between'
        container
        spacing={24}>
        <Grid item>
          <Typography
            gutterBottom
            variant='h3'
            display='inline'
            style={{
              fontWeight: "700",
              letteSpacing: "0.2px",
              fontSize: "25px",
            }}>
            Dashboard
          </Typography>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />
      {loader ?
        (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        )
        :
        <div className='dashboard_container' style={{ backgroundColor: '#fff', border: '1px solid rgba(76, 78, 100, 0.25)', borderRadius: '10px', padding: '10px' }}>
          <div style={{ width: "97%" }}>
            <Grid
              container
              spacing={2}>

            </Grid>
            <Grid>
              <Box mt={5}>
                <Typography style={{ color: "#000", fontSize: 25, fontWeight: 'bold' }}>{"Food Category"}</Typography>
              </Box>
            </Grid>
            <form onSubmit={(e) => {
              e.preventDefault();

              setLoaderAddCategory(true)
              AddSingleDoc("Categories", category).then(() => {
                setCategory({});
                setLoaderAddCategory(false)
                window.location.reload(false);
              });
              // setLoaderAddCategory(false)

            }}>
              <Grid item xs={12} xl={6} lg={6} md={6} style={{ marginTop: 20, }}>
                <InputField

                  type='text'
                  name='name'
                  placeholder={"Enter food category name"}
                  value={category.name || ''}
                  onChange={handleOnChange}
                  require={true}
                />
              </Grid>
              <Grid>
                <div style={{ marginTop: '10px', width: '50%' }}>
                  <ButtonIconComponent
                    loader={loaderAddCategory}
                    name='Add a Category'
                    // onClick={() => console.log("Export")}
                    imageBool={true}
                    styles={{ marginLeft: '10px' }}
                    type={'submit'}
                  />
                </div>
              </Grid>
            </form>
            <Grid container spacing={0} >
              {data?.map((i, index) => (
                 <Grid item xs={0} sm={4} md={0} key={index} >
                <Box mt={5} style={{ display: 'flex', alignItems: 'center', width: "70%" }} key={index}>
                  {i?.id != categoryIndex ? (
                    <>
                      <Typography style={{ color: "#000", marginLeft: 15 }}>{i?.name}</Typography>
                      <Tooltip title='Edit Category' onClick={() => setCategoryIndex(i?.id)}>
                        <IconButton>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>

                      {/* <Tooltip title='Delete Category' onClick={() => {( */}
                        {/* <AlertDialog open={true} /> */}
                  {/* )}}> */}
                        {/* <IconButton>
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip> */}

                      <RemoveButton
                        text={'Are you sure you want to delete this item?'} 
                        onRemove={() => handleRemove(i?.id)}
                        />
                    </>
                  )
                    :
                    <>
                      <form onSubmit={(e) => {
                        e.preventDefault()
                        let temp = data?.filter((item) => item?.id == i?.id)
                        console.log(temp)
                        UpdateSingleDoc("Categories", temp[0]?.id, temp[0])
                        setCategoryIndex(0)
                      }}
                        style={{
                          width: "100%",

                        }}
                      >

                        <Grid item xs={12} xl={8} lg={8} md={8} style={{ marginTop: 20, display: 'flex', alignItems: 'center', width: "100%" }}>
                          <InputField
                            type='text'
                            name='item'

                            placeholder={"Enter food category name"}
                            onChange={(e) => {
                              const updatedData = data.map(item => {
                                if (item.id === i?.id) {
                                  return { ...item, name: e.target.value };
                                }
                                return item;
                              });
                              setData(updatedData)
                              // console.log(updatedData)
                            }}
                            value={i?.name}
                            require={true}
                          />
                        </Grid>
                        <div style={{ marginTop: '20px', width: '20%', marginLeft: '10px' }}>
                          <ButtonComponent
                            loader={false}
                            name='Save'
                            // onClick={() => setCategoryIndex(0)}
                            imageBool={false}
                            styles={{ marginLeft: '10px' }}
                            type='submit'
                          />
                        </div>
                      </form>
                    </>
                  }
                </Box>
                </Grid> 
              ))}
             
            </Grid>

            {/* <Grid
          container
          justifyContent='center'
          sx={{ marginTop: "30px", width: "50%" }}>
          <ButtonComponent loader={false} name='Save' dashboard={true} />
        </Grid> */}
          </div>
        </div>
      }
    </React.Fragment>
  )
}

export default FoodCategory


